import React from 'react';
import type { PackageStatus } from '../types/docmagic';
const styles: Record<PackageStatus, string> = {
  Pending: 'bg-canvas text-muted border-line-strong',
  'In Progress': 'bg-[#eef4ff] text-[#0b5cab] border-[#c7dcf7]',
  Completed: 'bg-[#ebf7e6] text-success border-[#b9e0a8]',
  'Completed — PDF Pending': 'bg-[#fef5e6] text-warning border-[#f7d59c]',
  Declined: 'bg-[#fdeded] text-error border-[#f5b8b8]',
  'Sync Failed': 'bg-error text-white border-error'
};
interface StatusBadgeProps {
  status: PackageStatus;
  size?: 'sm' | 'md';
}
export function StatusBadge({
  status,
  size = 'md'
}: StatusBadgeProps) {
  return <span className={`inline-flex items-center whitespace-nowrap rounded border font-semibold ${styles[status]} ${size === 'sm' ? 'px-1.5 py-px text-[11px]' : 'px-2 py-0.5 text-xs'}`} data-id="element-132" data-mp="2rq6liywbq6en">
      {status}
    </span>;
}